import { render, staticRenderFns } from "./ServiceDashboardTutorCardHeaderSkeleton.vue?vue&type=template&id=677735ca&scoped=true&"
var script = {}
import style0 from "./ServiceDashboardTutorCardHeaderSkeleton.vue?vue&type=style&index=0&id=677735ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677735ca",
  null
  
)

export default component.exports